<template>
  <div id="container"></div>
</template>

<script>
import * as THREE from "three";
export default {
  name: "ThreeParticles",
  data() {
    return {
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      group: null,
      particlesData: [],
      positions: null,
      colors: null,
      particles: null,
      pointCloud: null,
      particlePositions: null,
      linesMesh: null,
      maxParticleCount: 1000,
      particleCount: 400,
      effectController: {
        showDots: true,
        showLines: true,
        minDistance: 250,
        limitConnections: false,
        maxConnections: 20,
        particleCount: 400
      }
    };
  },
  methods: {
    init: function() {
      let container = document.getElementById("container");
      let r = 1600;

      //  this.camera = new Three.PerspectiveCamera(
      //    70,
      //    container.clientWidth / container.clientHeight,
      //    0.01,
      //    10
      //  );
      //  this.camera.position.z = 1;
      //
      //  this.scene = new Three.Scene();
      //
      //  let geometry = new Three.BoxGeometry(0.2, 0.2, 0.2);
      //  let material = new Three.MeshNormalMaterial();
      //
      //  this.mesh = new Three.Mesh(geometry, material);
      //  this.scene.add(this.mesh);
      //
      //  this.renderer = new Three.WebGLRenderer({ antialias: true, alpha: true });
      //  this.renderer.setSize(container.clientWidth, container.clientHeight);
      //  container.appendChild(this.renderer.domElement);

      this.camera = new THREE.PerspectiveCamera(
        45,
        window.innerWidth / window.innerHeight,
        1,
        4000
      );

      this.camera.position.z = 1750;

      this.scene = new THREE.Scene();
      this.group = new THREE.Group();

      this.scene.add(this.group);

      var segments = this.maxParticleCount * this.maxParticleCount;

      this.positions = new Float32Array(segments * 3);
      this.colors = new Float32Array(segments * 3);

      var pMaterial = new THREE.PointsMaterial({
        color: 0xffffff,
        size: 3,
        blending: THREE.AdditiveBlending,
        transparent: true,
        sizeAttenuation: false
      });

      this.particles = new THREE.BufferGeometry();
      this.particlePositions = new Float32Array(this.maxParticleCount * 3);

      for (var i = 0; i < this.maxParticleCount; i++) {
        var x = Math.random() * r - r / 2;
        var y = Math.random() * r - r / 2;
        var z = Math.random() * r - r / 2;
        this.particlePositions[i * 3] = x;
        this.particlePositions[i * 3 + 1] = y;
        this.particlePositions[i * 3 + 2] = z;
        // add it to the geometry
        this.particlesData.push({
          velocity: new THREE.Vector3(
            -1 + Math.random() * 2,
            -1 + Math.random() * 2,
            -1 + Math.random() * 2
          ),
          numConnections: 0
        });
      }

      this.particles.setDrawRange(0, this.particleCount);
      this.particles.addAttribute(
        "position",
        new THREE.BufferAttribute(this.particlePositions, 3).setDynamic(true)
      );

      // create the particle system
      this.pointCloud = new THREE.Points(this.particles, pMaterial);
      this.group.add(this.pointCloud);

      var geometry = new THREE.BufferGeometry();
      geometry.addAttribute(
        "position",
        new THREE.BufferAttribute(this.positions, 3).setDynamic(true)
      );

      geometry.addAttribute(
        "color",
        new THREE.BufferAttribute(this.colors, 3).setDynamic(true)
      );

      geometry.computeBoundingSphere();
      geometry.setDrawRange(0, 0);

      var material = new THREE.LineBasicMaterial({
        vertexColors: THREE.VertexColors,
        blending: THREE.AdditiveBlending,
        transparent: true
      });

      this.linesMesh = new THREE.LineSegments(geometry, material);
      this.group.add(this.linesMesh);
      //
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      this.renderer.gammaInput = true;
      this.renderer.gammaOutput = true;

      container.appendChild(this.renderer.domElement);
    },
    render() {
      var time = Date.now() * 0.001;
      this.group.rotation.y = time * 0.1;
      this.renderer.render(this.scene, this.camera);
    },
    animate() {
      //  requestAnimationFrame(this.animate);
      //  this.mesh.rotation.x += 0.01;
      //  this.mesh.rotation.y += 0.02;
      //  this.renderer.render(this.scene, this.camera);

      var vertexpos = 0;
      var colorpos = 0;
      var numConnected = 0;

      for (let i = 0; i < this.particleCount; i++) {
        this.particlesData[i].numConnections = 0;
      }

      for (let i = 0; i < this.particleCount; i++) {
        // get the particle
        var particleData = this.particlesData[i];
        this.particlePositions[i * 3] += particleData.velocity.x;
        this.particlePositions[i * 3 + 1] += particleData.velocity.y;
        this.particlePositions[i * 3 + 2] += particleData.velocity.z;
        if (
          this.particlePositions[i * 3 + 1] < -this.rHalf ||
          this.particlePositions[i * 3 + 1] > this.rHalf
        )
          particleData.velocity.y = -particleData.velocity.y;
        if (
          this.particlePositions[i * 3] < -this.rHalf ||
          this.particlePositions[i * 3] > this.rHalf
        )
          particleData.velocity.x = -particleData.velocity.x;
        if (
          this.particlePositions[i * 3 + 2] < -this.rHalf ||
          this.particlePositions[i * 3 + 2] > this.rHalf
        )
          particleData.velocity.z = -particleData.velocity.z;
        if (
          this.effectController.limitConnections &&
          particleData.numConnections >= this.effectController.maxConnections
        )
          continue;

        // Check collision
        for (var j = i + 1; j < this.particleCount; j++) {
          var particleDataB = this.particlesData[j];
          if (
            this.effectController.limitConnections &&
            particleDataB.numConnections >= this.effectController.maxConnections
          )
            continue;

          var dx =
            this.particlePositions[i * 3] - this.particlePositions[j * 3];
          var dy =
            this.particlePositions[i * 3 + 1] -
            this.particlePositions[j * 3 + 1];
          var dz =
            this.particlePositions[i * 3 + 2] -
            this.particlePositions[j * 3 + 2];
          var dist = Math.sqrt(dx * dx + dy * dy + dz * dz);

          if (dist < this.effectController.minDistance) {
            particleData.numConnections++;
            particleDataB.numConnections++;
            var alpha = 1.0 - dist / this.effectController.minDistance;
            this.positions[vertexpos++] = this.particlePositions[i * 3];
            this.positions[vertexpos++] = this.particlePositions[i * 3 + 1];
            this.positions[vertexpos++] = this.particlePositions[i * 3 + 2];
            this.positions[vertexpos++] = this.particlePositions[j * 3];
            this.positions[vertexpos++] = this.particlePositions[j * 3 + 1];
            this.positions[vertexpos++] = this.particlePositions[j * 3 + 2];
            this.colors[colorpos++] = alpha;
            this.colors[colorpos++] = alpha;
            this.colors[colorpos++] = alpha;
            this.colors[colorpos++] = alpha;
            this.colors[colorpos++] = alpha;
            this.colors[colorpos++] = alpha;
            numConnected++;
          }
        }
      }

      this.linesMesh.geometry.setDrawRange(0, numConnected * 2);
      this.linesMesh.geometry.attributes.position.needsUpdate = true;
      this.linesMesh.geometry.attributes.color.needsUpdate = true;
      this.pointCloud.geometry.attributes.position.needsUpdate = true;
      requestAnimationFrame(this.animate);

      this.render();
    }
  },
  mounted() {
    this.init();
    this.animate();
  }
};
</script>

<style scoped>
#container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
</style>